/**
 * @file ReportsApiService.js
 * @description Axios HTTP client configuration specifically for reports API endpoints.
 * Features:
 * - Similar to http.js but uses REPORTS_API_URL instead of CUSTOMER_API_URL
 * - Automatic token attachment and refresh
 * - Device and app information headers
 * - Centralized reports API communication
 * - Token refresh on 401 responses
 */
import axios from 'axios';
import { REPORTS_API_URL, baseHeaders, mobileHeaders, attachAuthInterceptor, attachRefreshInterceptor } from './Utils';

const headers = { ...baseHeaders, ...mobileHeaders };
export const ReportsApiService = axios.create({
  baseURL: REPORTS_API_URL,
  timeout: 1000 * 60,
  headers,
});

/**
 * Request interceptor to add authentication token to all requests
 * Retrieves the stored access token from storage and attaches it as a Bearer token
 */
attachAuthInterceptor(ReportsApiService);
/**
 * Response interceptor to handle token refresh on 401 Unauthorized responses
 * Attempts to refresh the access token using the refresh token
 * Retries the original request with the new token on success
 * Redirects to login on refresh failure
 */
// Handle expired access tokens
attachRefreshInterceptor(ReportsApiService);
